<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1COKTb2/tc-custom/9781504056991.jpg?1705379643202" alt="This image is the cover for the book Patricia Potter Western Romance Collection Volume Two"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Patricia Potter Western Romance Collection Volume Two
      </h1>
      <p class="bookDescription body article font2">
        <b>A trio of historical western romances by an award-winning, <i>USA Today</i>–bestselling author who “soars above the rest” (<i>Literary Times</i>).</b><br/>  <br/><i>Diablo</i>: Former Confederate Kane O’Brien is now a spy for the Yanks, sent to infiltrate and destroy a notorious outlaw refuge in Texas. But the mission gets complicated when he meets Nicky Thompson, a desperate beauty who is hiding there. Now she’s entrusting her life to a sensual stranger whose secret objective may doom them both.<br/>  <br/> “If you like Jo Goodman, you’re probably wishing there were more Wild West stories in the same vein. Fortunately for you . . . Patricia Potter wrote <b><i>Diablo</i></b><i>.</i>” —<i>All About Romance</i><br/>  <br/><i>Defiant</i>: A widowed young mother, Mary Jo Williams is new to Colorado territory when she finds herself tending to a wounded outlaw. Wade Foster can’t ignore the passion between them—or the danger he’s putting her in. To have a future with Mary Jo, he’ll have to put his past to rest by taking out the band of killers on his tail.<br/>  <br/> “<i>Defiant</i> is the next word in great historical romance!” —<i>Literary Times</i><br/>  <br/><i>Wanted</i>: Wrongly accused of murder, Texas ranger Morgan Davis is out to nab the real killer. He didn’t count on being seduced by the man’s sister, Lori, a crack-shot temptress who’ll do anything to save her brother from the gallows. But falling in love with Morgan was the last thing she wanted—and the most dangerous thing that could have happened.<br/>  <br/> “Patricia Potter is a master storyteller, a powerful weaver of romantic tales.” —Mary Jo Putney, <i>New York Times</i>–bestselling author<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Potter
      </h2>
      
      <p class="authorDescription body article">Patricia Potter is a <I>USA Today</I>&ndash;bestselling author of more than fifty romantic novels. A seven-time RITA Award finalist and three-time Maggie Award winner, she was named Storyteller of the Year by <I>Romantic Times</I> and received the magazine&rsquo;s Career Achievement Award for Western Romance. Potter is a past board member and president of Romance Writers of America. Prior to becoming a fiction author, she was a reporter for the <I>Atlanta Journal </I>and the president of a public relations firm in Atlanta. She lives in Memphis, Tennessee.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b4055262